import './Signup.css';
import SERVER_URL from '../../env.js';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useAuthorization } from '../../Utils/AuthUtils.js';


function Signup() {
    const navigate = useNavigate()

    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');

    const { authInfo } = useAuthorization()
    useEffect(() => {
        if (authInfo?.user) {
            navigate('/dashboard')
        }
    }, [authInfo, navigate]);


    const handleEmail = (e) => {
        setEmail(e.target.value);
    };

    const handleFirstName = (e) => {
        setFirstName(e.target.value);
    };

    const handleLastName = (e) => {
        setLastName(e.target.value);
    };

    const handlePassword = (e) => {
        setPassword(e.target.value);
    };

    const handleConfirmPassword = (e) => {
        setConfirmPassword(e.target.value);
    };

    const handleSignup = () => {
        fetch(SERVER_URL + '/auth/signup', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: email,
                firstName: firstName,
                lastName: lastName,
                password: password,
                confirmPassword: confirmPassword,
            }),
        })
            .then((res) => res.json())
            .then((data) => handleResult(data));
    };

    const handleResult = (data) => {
        if (!data.error) {
            Cookies.set('accessToken', data.accessToken, { expires: 30 })
            Cookies.set('refreshToken', data.refreshToken, { expires: 30 })
            navigate('/dashboard')
        } else {
            setMessage(data.error);
        }
    };

    return (
        <div className="Signup">
            <div className="Signup-box">
                {message && <div className="Signup-error-message"> {message}</div>}
                <div className="Signup-form">
                    <div className="Signup-input-container">
                        <input className="Signup-input" type="text" placeholder="Email" onChange={handleEmail} />
                        <input className="Signup-input" type="text" placeholder="First Name" onChange={handleFirstName} />
                        <input className="Signup-input" type="text" placeholder="Last Name" onChange={handleLastName} />
                        <input className="Signup-input" type="password" placeholder="Password" onChange={handlePassword} />
                        <input className="Signup-input" type="password" placeholder="Confirm Password" onChange={handleConfirmPassword} />
                    </div>
                    <div className="Signup-button" onClick={handleSignup}>Sign Up</div>
                </div>
            </div>
        </div>
    );
}

export default Signup;